import { ancestorNodeOfType } from "./ancestors.js";
import { getEnvironmentName } from "./environments.js";

export const mathAncestorNode = (state, pos) =>
    ancestorNodeOfType(state, pos, "$MathContainer") ||
    ancestorNodeOfType(state, pos, "EquationEnvironment") ||
    ancestorNodeOfType(state, pos, "EquationArrayEnvironment");

function findFirstMathNode(node) {
    if (!node) {
        return null;
    }
    if (node.type.name === "Math") {
        return node;
    }

    for (let child = node.firstChild; child; child = child.nextSibling) {
        const result = findFirstMathNode(child);
        if (result) {
            return result;
        }
    }
    return null;
}

export const isPrimaryMathNodeForContainer = (nodeRef, ancestorNode) => {
    const firstMathNode = findFirstMathNode(ancestorNode);
    return Boolean(firstMathNode && firstMathNode.from === nodeRef.from && firstMathNode.to === nodeRef.to);
};

export const parseMathContainer = (state, nodeRef, ancestorNode) => {
    const innerContent = state.doc.sliceString(nodeRef.from, nodeRef.to).trim();
    if (!innerContent.length) {
        return null;
    }

    let content = innerContent;
    let displayMode = false;
    let passToMathJax = true;
    let pos = nodeRef.from;

    if (ancestorNode.type.is("$Environment")) {
        const environmentName = getEnvironmentName(ancestorNode, state);
        if (environmentName) {
            if (environmentName === "tikzcd") {
                passToMathJax = false;
            }
            if (environmentName !== "math" && environmentName !== "displaymath") {
                content = state.doc.sliceString(ancestorNode.from, ancestorNode.to).trim();
                pos = ancestorNode.from;
            }
            if (environmentName !== "math") {
                displayMode = true;
            }
        }
    } else if (ancestorNode.type.is("BracketMath") || Boolean(ancestorNode.getChild("DisplayMath"))) {
        displayMode = true;
    }

    return { content, displayMode, passToMathJax, pos };
};
